import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { featureService } from '@kss/api';
import type { FeatureCreate } from '@kss/api';

const columns: BulkColumn<FeatureCreate>[] = [
  { key: 'code', header: 'Code', sample: 'inventory.transfer' },
  { key: 'name', header: 'Name', required: true, sample: 'Inventory transfers' },
  { key: 'category', header: 'Category', sample: 'Inventory' },
  { key: 'description', header: 'Description' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkFeature() {
  return (
    <BulkSpreadsheet<FeatureCreate> title="Bulk import features" entityLabel="feature" backPath="/panel/features" columns={columns} module="Feature"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await featureService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
